import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundInpaint from '../pages/PagePlaygroundInpaint'

type PlaygroundRunSearch = {
  runId?: string
}

export const Route = createFileRoute('/playground/inpaint')({
  component: PagePlaygroundInpaint,
  validateSearch: (search: Record<string, unknown>): PlaygroundRunSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined
  })
})
